import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKERS_LEGISLATIVE_BODIES = defineFcm('decision_makers_legislative_bodies')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		if (countryValue || localeValue) return localeValue && countryValue;
		return globalValue;
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'TBD',
		context:
			'On the petition page DM section, controls whether that UI/UX is anchored around legislative bodies and the Sunrise look',
		description: 'When false, DM section uses current UI/UX without groupped DMs and also without Sunrise look',
		mergeLogic: 'Displays a combined country & locale if either is set, otherwise global value is used',
		import: false,
	});
